import Vue from 'vue'
import Router from 'vue-router'
import Home from 'components/Home'

import Course from 'components/global/Course'

import Appointment from 'components/global/submodule/Appointment'
import Assignment from 'components/global/submodule/Assignment'
import Calendar from 'components/global/submodule/Calendar'
import Quiz from 'components/global/submodule/Quiz'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:courseId',
      component: Course,
      children: [
        {
          path: 'calendar',
          name: 'Calendar',
          component: Calendar
        },
        {
          path: 'appointment',
          name: 'Appointment',
          component: Appointment
        },
        {
          path: 'assignment/:assignmentId',
          name: 'Assignment',
          component: Assignment
        },
        {
          path: 'quiz/:quizId',
          name: 'Quiz',
          component: Quiz
        },
        {
          path: '*',
          redirect: {
            name: 'Calendar'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js